<template>
  <div style="margin-top:20px;">
    <!--<div v-if="data.que_type==11" v-for="(item,i) in data.subList" :key="i">-->
    <!--</div>-->
    <div v-for="(item,i) in data.subList" :key="i">
      <!-- 单选   -->
      <div v-if="item.que_type==1&&item.show" class="timu" >
        <div class="title">{{item.que_content}}<span class="beizhu"> ( 单选 )</span></div>
        <div v-for="(list,index) of item.siteQuestionAnswerList" :key="index">
          <el-radio v-model="item.as" @change='changes(item)'class="xuanxiang" :key="index" :label="list.answer_content"></el-radio>
        </div>
      </div>
      <!-- 输入框题目 -->
      <div class="timu" v-else-if="item.que_type==5&&item.show">
        <div class="title">{{item.que_content}}<span class="beizhu"> ( 输入框 )</span></div>
        <div class="shurukuangBox">
          <input @change="changes(item)" v-model="item.as" class="inputs" type="text" :maxlength="item.maxlength" :placeholder="item.placeholder" @input="cenggao(item)" @blur="inputBlur(item)"/>
        </div>
      </div>
      <!--根据父级输入值的大小来判断选项是否显示     多选加输入框         -->
      <div v-else-if="item.que_type==6&&data.que_type==10">
        <div class="timu" v-if="item.show">
          <div class="title">{{item.que_content}}<span class="beizhu"> ( 多选 )</span></div>
          <div v-for="(list,i) of item.siteQuestionAnswerList" :key="i">
            <el-checkbox v-if="list.show" @change="inputChange(item,list)" class="xuanxiang" v-model="list.as">{{list.answer_content}}</el-checkbox>
            <div class="shurukuangBox"  v-show="list.as&&list.answer_content!='都没有'">
              <input class="inputs" @input="inputChange(item,list)" @blur="qingqiu(item,list)" style="padding-left:20px;" v-model="list.num" type="text" :maxlength="item.maxlength" :placeholder="item.placeholder"/>
            </div>
          </div>
        </div>
      </div>
      <!-- 多选加输入框         -->
      <div class="timu" v-else-if="item.que_type==6">
        <div class="title">{{item.que_content}}<span class="beizhu"> ( 多选 )</span></div>
        <div v-for="(list,i) of item.siteQuestionAnswerList" :key="i">
          <el-checkbox @change="inputChange(item,list)" class="xuanxiang" v-model="list.as">{{list.answer_content}}</el-checkbox>
          <div class="shurukuangBox"  v-show="list.as&&list.answer_content!='都没有'">
            <input class="inputs" @input="inputChange(item,list)" @blur="qingqiu(item,list)" v-model="list.num" type="text" style="padding-left:20px;" :maxlength="item.maxlength" :placeholder="item.placeholder"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'zitimu',
  props: ['datas'],
  data () {
    return {
      data: {}
    }
  },
  mounted: function() {
    this.data = this.datas;
    this.setData();
  },
  methods: {
    cenggao(item,list){
      if(item.id==40&&item.as){//这个是输入层高的题目
        console.log(item.as,6666)
        for(var i=1;i<=item.as.length;i++){
          if(i==1){
            /^[1-9]{1}$/.test(item.as.slice(0,1))?'':this.$set(item,'as',"");
          }else if(i==2){
            if(item.as.slice(1,2)=='.'||item.as.slice(1,2)=='。'){
              this.$set(item,'as',item.as.slice(0,1)+'.'+item.as.slice(2,4))
            }else{
              this.$set(item,'as',item.as.slice(0,1))
            }
          }else if(i==3){
            /^[0-9]{1}$/.test(item.as.slice(2,3))?'':this.$set(item,'as',item.as.slice(0,2));
          }else if(i==4){
            /^[0-9]{1}$/.test(item.as.slice(3,4))?'':this.$set(item,'as',item.as.slice(0,3));
          }
        }
      }else{
        if(item.as&&item.as.length==1){
          this.$set(item,'as',item.as.replace(/[^1-9]/g,''))
        }else if(item.as){
          this.$set(item,'as',item.as.replace(/[^0-9]/g,''))
        };
      }
      item.as?this.$set(item,'userQuestionAnswerList',[{'answer':item.as}]):this.$set(item,'userQuestionAnswerList',[]);
      this.$emit('datachange',this.data,item,list)
    },
    qingqiu(item,list){
      this.$emit('datachange',this.data,item,list)
    },
    inputChange(item,list){
      if(item.que_type==5){
      if(/^[0-9]{1,6}$/.test(item.as)){
        if(item.as&&item.as.length == 1){this.$set(item,'as',item.as.replace(/[^1-9]/g,''))}else{this.$set(item,'as',item.as.replace(/[^0-9]/g,''))}
      }else{
        this.$set(item,'as','')
      }
      item.as?this.$set(item,'userQuestionAnswerList',[{'answer':item.as}]):this.$set(item,'userQuestionAnswerList',[]);
    }else if(item.que_type==6){
      if(/^[0-9]{1,6}$/.test(list.num)){
        if(list.num&&list.num.length == 1){this.$set(list,'num',list.num.replace(/[^1-9]/g,''))}else{this.$set(list,'num',list.num.replace(/[^0-9]/g,''))}
      }else{
        this.$set(list,'num','')
      }
      if(list.answer_content=='都没有'&&list.as){
        for(var i=0;i<item.siteQuestionAnswerList.length-1;i++){
          this.$set(item.siteQuestionAnswerList[i],'as',false)
        }
        this.$set(item,'userQuestionAnswerList',[])
        item.userQuestionAnswerList.push({'answer':list.answer_content})
      }else if(list.as){
        this.$set(item,'userQuestionAnswerList',[])
        item.siteQuestionAnswerList.forEach((ite,ind)=>{
          ite.as?item.userQuestionAnswerList.push({'answer':ite.answer_content,'number':ite.num}):'';
        })
        this.$set(item.siteQuestionAnswerList[item.siteQuestionAnswerList.length-1],'as',false)
      }else{
        this.$set(item,'userQuestionAnswerList',[])
        item.siteQuestionAnswerList.forEach((ite,ind)=>{
          ite.as?item.userQuestionAnswerList.push({'answer':ite.answer_content,'number':ite.num}):'';
        })
      }
    }
    if(yanzheng=="yanzheng"){
      this.$emit('datachange',this.data,item,list)
    }
    },
    inputBlur(item){
      if(item.id==40){//这个是输入层高的题目
        if(item.as.length==2&&item.as.slice(1,2)=='.'){
          this.$set(item,'as',item.as.slice(0,1))
        }
      }
    },
    //用户填写资料给相应的组件赋值
    changes(item,list,data){
      if(item.que_type==1){
        item.userQuestionAnswerList = {'answer':item.as}
      }
      this.$emit('datachange',this.data,item,list)
    },
    setData(){
      this.data.subList.forEach((item,i)=>{
        // if(this.data.que_type==7){
        //   if(item.limit_compare==1){
        //     this.$set(item,'show',this.data.as>item.limit_number);
        //   }else if(item.limit_compare==2){
        //     this.$set(item,'show',this.data.as>=item.limit_number);
        //   }else if(item.limit_compare==3){
        //     this.$set(item,'show',this.data.as<item.limit_number);
        //   }else if(item.limit_compare==4){
        //     this.$set(item,'show',this.data.as<=item.limit_number);
        //   }else if(item.limit_compare==5){
        //     this.$set(item,'show',this.data.as==item.limit_number);
        //   }
        // }
        if(item.que_type==6){
          item.siteQuestionAnswerList.forEach((list,j)=>{
            if(list.limit_number==0){
              this.$set(list,'show',true);
            }else if(this.data.as > list.limit_number){
              this.$set(list,'show',true);
            }else{
              this.$set(list,'show',false);
              //bug以后再改， 在答案里要把隐藏的这个对象删掉 ，或者这个题目重新赋值答案
            }
          })
          var num = 0; //如果之题目只有一个都没有，就不显示本题了
          item.siteQuestionAnswerList.forEach((list,j)=>{
            if(list.show&&list.answer_content=="都没有"){
              num++;
            }else if(list.show){
              num++;
            }
          })
          num<=1?this.$set(item,'show',false):this.$set(item,'show',true);
        }
      })
    },
  },
  watch: {
    datas: {
      deep: true,    // 这句重要
      handler (val) {
        this.data=val;
        this.setData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  input::-webkit-input-placeholder { /* WebKit browsers */
    color:#ccc;
  }
  .title {
    padding: 0;
    line-height: 35px;
    font-size:15px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    line-height: 37px;
    margin:0 0 0 31px;
  }
  .beizhu{
    font-weight:400;
    color:#808080;
    font-size:12px;
  }
  .timu{
    background: #F9F9F9;
    /*border: 0.5px solid #DADADA;
    margin:-1px 0 0 28px;
    width:845px;
    padding: 0 0 15px 0;*/
  }
  .xuanxiang{
    line-height:40px;
    margin:0 0 0 31px;
  }
  .inputs{
    width:100%;
    height:50px;
    background: white;
    border:0.5px solid #DADADA;
    padding: 0 0 0 20px;
  }
  .shurukuangBox {
    padding: 5px 0;
    background: #f9f9f9;
    margin:0 32px;
  }
</style>



// WEBPACK FOOTER //
// src/view/zitimu.vue